import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetContentBlock,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { TextInput } from '@/components/inputs/TextInput'

export interface CreateJobConfirmationDialogProps {
  showing: boolean
  onClose: () => unknown
  memberName: string
  workspaceName: string
  confirmationInput: string
  onConfirmationInputChange: (value: string) => unknown
  canConfirm: boolean
  isPending: boolean
  onConfirm: () => unknown
}

export function CreateJobConfirmationDialog({
  showing,
  onClose,
  memberName,
  workspaceName,
  confirmationInput,
  onConfirmationInputChange,
  canConfirm,
  isPending,
  onConfirm,
}: CreateJobConfirmationDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentTitle>Confirm job creation</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Are you sure you want to create a job for{' '}
          <strong>{memberName}</strong> in <strong>{workspaceName}</strong>?
        </ModalSheetContentDescription>
        <ModalSheetContentDescription compact>
          Type the workspace name to continue.
        </ModalSheetContentDescription>
        <ModalSheetContentBlock expanded>
          <TextInput
            value={confirmationInput}
            onChange={(event) => onConfirmationInputChange(event.target.value)}
            onPaste={(event) => event.preventDefault()}
            onDrop={(event) => event.preventDefault()}
            autoFocus
          />
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            isDisabled={isPending}
            onPress={onClose}
          />
          <Button
            label="Create job"
            variant="primary"
            onPress={onConfirm}
            isDisabled={!canConfirm || isPending}
            isPending={isPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
